export const OrgStepIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g clipPath="url(#clip0_4983_65079)">
      <path
        d="M23.1155 21.2022V16.7286H13.4227V13.7048C14.5085 13.5841 15.517 13.2034 16.3843 12.6264C16.3016 11.8 15.9448 10.9962 15.3132 10.3646C13.8596 8.91105 11.4945 8.911 10.041 10.3646C9.40941 10.9962 9.05256 11.8 8.9699 12.6264C9.83718 13.2034 10.8457 13.5842 11.9315 13.7048V16.7286H2.23875V21.2022H0.00195312V25.6758H5.96673V21.2022H3.72994V18.2198H11.9315V21.2022H9.69472V25.6758H15.6595V21.2022H13.4227V18.2198H21.6243V21.2022H19.3875V25.6758H25.3523V21.2022H23.1155Z"
        fill="#175CE5"
      />
      <path
        d="M10.4573 8.27739C8.7472 6.3964 10.1112 3.29844 12.6786 3.30758C15.2458 3.29839 16.61 6.39679 14.8999 8.27734C16.212 8.893 17.247 10.0538 17.6783 11.506C21.5231 7.27292 18.4543 0.304514 12.6784 0.325242C6.90294 0.304464 3.83371 7.27406 7.67876 11.5061C8.11081 10.0515 9.14734 8.89196 10.4573 8.27739Z"
        fill="#175CE5"
      />
      <path
        d="M11.1855 6.29002C11.1855 7.11227 11.8545 7.78122 12.6767 7.78122C14.655 7.6993 14.6544 4.88045 12.6767 4.79883C11.8545 4.79883 11.1855 5.46778 11.1855 6.29002Z"
        fill="#175CE5"
      />
    </g>
    <defs>
      <clipPath id="clip0_4983_65079">
        <rect width="25.3503" height="25.3503" fill="white" transform="translate(0 0.325195)" />
      </clipPath>
    </defs>
  </svg>
);
